'use client'

import { BillingPlans } from '@/features/subscription/billing/billing-plans/billing-plans'
import { BillingPlansLandingDesign } from '@/features/subscription/billing/billing-plans/billing-plans-landing-design'
import { useBillingUser } from '@/features/subscription/billing/billing-user-context'

export const PlansTab = ({ highlightedPlan }: { highlightedPlan?: string }) => {
    const billingUser = useBillingUser()
    const currentPlan = billingUser?.currentActiveSubscription?.subscriptionType
    const effectiveHighlight = highlightedPlan ?? currentPlan

    return (
        <BillingPlansLandingDesign>
            <BillingPlans
                showSectionsBelow={false}
                getHighlightedPlan={
                    effectiveHighlight == null
                        ? undefined
                        : (plans) =>
                              plans.some((plan) => plan.type === effectiveHighlight)
                                  ? effectiveHighlight
                                  : undefined
                }
            />
        </BillingPlansLandingDesign>
    )
}
